import AppTypes from "store/app/app.types";
import { MiddlewareStore } from "store/createStore";
import { IChatMessage } from "store/messages/messages.state";

// handles only non meta messages that are chat components;
export const handleSmartagentMessage = async (message: IChatMessage, store: MiddlewareStore) => {

    if (!["text/plain", "text/markdown"].includes(message.contentType)) return message;

    if (typeof message.content !== 'object') return message;

    if (message.content.type === "SILENT_STATE_UPDATE") {
        if (message.content.language) {
            store.dispatch({
                type: AppTypes.SET_LANGUAGE,
                payload: message.content.language
            })
        } else {
            console.log('This is a SILENT_STATE_UPDATE without a language set. This will be ignored by the App and Redux')
        }
        message.discarded = true;
    }

    if (message.content.type === "INVISIBLE_MESSAGE") {
        message.discarded = true;
    }

    if (message.content.type === "BATCH") {
        return message.content.messages.map((batchMessage, i) => ({
            ...message,
            content: batchMessage,
            id: `${message.id}-${i}`
        }))
    }

    return message;

}